module.exports = __webpack_public_path__ + "img/fruit-tomatoes-350x184.92929a98.jpg";